"use client";

export function EducatorsHeroSection() {
  return (
    <section className="bg-surface-200 relative py-20 md:py-28 min-h-[60vh] md:min-h-[70vh] flex items-center">
      {/* Mobile background */}
      <div className="absolute inset-0 bg-[url('/images/marketing/educators/hero/backgroundMobile.webp')] bg-cover bg-center bg-no-repeat md:hidden" />
      {/* Desktop background */}
      <div className="absolute inset-0 hidden md:block bg-[url('/images/marketing/educators/hero/background.webp')] bg-cover bg-center bg-no-repeat" />
      <div className="container mx-auto px-6 max-w-6xl relative z-10 mt-16 md:mt-0">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-12 text-center">
            <h1 className="text-4xl md:text-6xl font-extrabold text-black">
              Kid-loved,
              <br className="hidden md:inline" />
              Teacher-approved!
            </h1>
            <p className="mt-5 text-base md:text-xl font-semibold text-black/80">
              Join the growing community of educators who
              <br className="hidden md:inline" />
              are enriching math classes with play.
            </p>
            <div className="mt-6 flex items-center justify-center gap-4">
              <a
                href="/games"
                aria-label="Navigate to math games page"
                className="inline-block bg-orange-500 text-black px-10 sm:px-14 py-5 md:py-5 lg:py-7 rounded-full charlie-kingdom-font text-4xl md:text-4xl lg:text-5xl hover:bg-orange-400 shadow-cta-orange border-4 border-black relative rotate-[-3deg]"
              >
                <span className="relative -top-1">Play Math</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
